const benchmarkScopeDescriptionKeys: Record<string, string> = {
    local: 'translate_benchmark_scope_local_description',
    national: 'translate_benchmark_scope_national_description',
    international: 'translate_benchmark_scope_international_description',
};

export const benchmarkScopeDescriptionTranslationKeys = Object.values(
    benchmarkScopeDescriptionKeys
);

export function mapBenchmarkScopeOptions<T extends { id: string }>(
    items: T[],
    translate: (key: string) => string
): Array<T & { description: string }> {
    return items.map(item => ({
        ...item,
        description: benchmarkScopeDescriptionKeys[item.id]
            ? translate(benchmarkScopeDescriptionKeys[item.id])
            : '',
    }));
}
